
const firebaseConfig = {
    apiKey: "AIzaSyA5CbdAHCtdnlVJMi8tnx5kycnlgDX_gZo",
    authDomain: "assinment-10-d1b32.firebaseapp.com",
    projectId: "assinment-10-d1b32",
    storageBucket: "assinment-10-d1b32.appspot.com",
    messagingSenderId: "952038896824",
    appId: "1:952038896824:web:69622691cb7887138a704d"
};
export default firebaseConfig;

